import { ENV } from "@/config/env";

// 認証トークンと検証コード用の自前エンドポイント
export const AUTH_ISSUE_CODE = `${ENV.AUTH_API_ENDPOINT}/auth/issue-code`;
export const AUTH_EXCHANGE = `${ENV.AUTH_API_ENDPOINT}/auth/exchange`;
export const WHOAMI = `${ENV.AUTH_API_ENDPOINT}/auth/whoami`;
export const AUTH_REFRESH = `${ENV.AUTH_API_ENDPOINT}/auth/refresh`;
// PRODUCT_DEV-396 セキュリティ設定/パスキー関連
export const AUTH_ME = `${ENV.AUTH_API_ENDPOINT}/auth/me`;
export const AUTH_LOGIN_OPTIONS = `${ENV.AUTH_API_ENDPOINT}/auth/login-options`;
// PRODUCT_DEV-421 エイリアスログイン用
export const AUTH_RESOLVE_ALIAS = `${ENV.AUTH_API_ENDPOINT}/auth/resolve-alias`;
